export default {
  HOMEPAGE: {
    TITLE: 'Homepage',
    PRODUCTS: {
      FIRSTCARD: 'Meet your <br>Sleep buddies',
      SECONDCARD: 'Your New <br>Favorite Pajamas'
    },
    SLIDINGPANEL: {
      PREVIOUS: 'Previous',
      NEXT: 'Next'
    },
    WHYHIKARUSA: {
      TITLE: 'Welcome to Hikarusa Group',
      DESC: `Kami adalah bagian penting untuk menemani didalam rumahmu, 
      diciptakan menjadi teman tidur terbaik yang pernah kamu miliki. 
      <br/><br/>
      Dengan kelembutan dan kenyamanan dari TENCEL™ Modal,terasa sangat lembut disetiap sentuhan, 
      hypoallergenic yang aman bagi kulit, dingin dan aman tentunya, karena bebas dari bahan kimia berbahaya.
      <br/><br/>
      TENCEL™ Modal untuk kelembutan dan kebaikan lingkungan, berbahan ramah lingkungan untuk masa depan lebih baik, 
      rasakan kelembutan terbaik dari alam ditangan anda.`,
      BTNTEXT: 'Learn More'
    },
    INSTAGRAM: {
      TITLE: 'Follow us &#64;HikarusaBaby'
    }
  }
}
